(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-device-releases', {
                parent: 'update_management',
                url: '/tab-device-releases?sort&search&objectType',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases.html',
                        controller: 'TabDeviceReleasesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: [],
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    objectType: {
                        value: '-1',
                        squash: true
                    },
                    itemsPerPageChosen: null,
                    device: {
                        value: '-1',
                        squash: true
                    },
                    predicates: {}
                }, resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search,
                            objectType: $stateParams.objectType,
                            device: $stateParams.device
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-device-releases-detail', {
                parent: 'tab-device-releases',
                url: '/tab-device-releases/{id}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-detail.html',
                        controller: 'TabDeviceReleasesDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDeviceReleases', function ($stateParams, TabDeviceReleases) {
                        return TabDeviceReleases.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-device-releases-new', {
                parent: 'tab-device-releases',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-dialog.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }], entity: function () {
                        return {
                            deviceReleaseName: null,
                            deviceReleaseDescription: null,
                            isActive: false,
                            deviceReleaseVersion: null,
                            id: null
                        };
                    }
                }
            })
            .state('tab-device-releases-edit', {
                parent: 'tab-device-releases',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-dialog.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }], entity: ['$stateParams', 'TabDeviceReleases', function ($stateParams, TabDeviceReleases) {
                        return TabDeviceReleases.get({id: $stateParams.id});

                    }]
                }
            })
            .state('tab-device-releases-upgrade', {
                parent: 'tab-device-releases',
                url: '/{id}/upgrade',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'jotApp.tabDeviceReleases.upgrade.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-upgrade.html',
                        controller: 'TabDeviceReleasesDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDeviceReleases');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDeviceReleases', '$q', function ($stateParams, TabDeviceReleases, $q) {
                        var deviceRelease = $q.defer();
                        TabDeviceReleases.get({id: $stateParams.id}).$promise.then(function (data) {
                            data.id = null;
                            deviceRelease.resolve(data);
                        });
                        return deviceRelease.promise;
                    }]
                }
            })
            .state('tab-device-releases.delete', {
                parent: 'tab-device-releases',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-delete-dialog.html',
                        controller: 'TabDeviceReleasesDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDeviceReleases', function (TabDeviceReleases) {
                                return TabDeviceReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-device-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('tab-device-releases.enable', {
                parent: 'tab-device-releases',
                url: '/{id}/enable',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-device-releases/tab-device-releases-enable-dialog.html',
                        controller: 'TabDeviceReleasesEnableController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDeviceReleases', function (TabDeviceReleases) {
                                return TabDeviceReleases.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-device-releases', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
